import React from 'react'
import AutoComplete from 'material-ui/AutoComplete'
import MenuItem from 'material-ui/MenuItem'
import ArrowIcon from 'Assets/Images/icons/arrow'

/**
 * @param {{className, hasPrimaryText, primaryText, options}} props
 */
export const AutoCompleteUnstyled = props => {
  const dataSource = props.options.map(option => ({
    text: option.label,
    value: (
      <MenuItem
        primaryText={option.label}
        style={{ width: '100%' }}
        innerDivStyle={{ width: '100%', padding: '0 20px' }}
      />
    ),
  }))

  const handleBlur = element => {
    handleNewRequest(element.target.value)
  }

  const handleNewRequest = chosen => {
    const term = chosen.text || chosen
    const option = props.options.find(o => o.label === term) || {}
    props.onChange(option.value)
  }

  return (
    <div className={`${props.className} form-select`}>
      <label className="label">{props.label}</label>
      <AutoComplete
        className="select-field"
        style={{ width: '100%' }}
        inputStyle={{
          borderRadius: 4,
          paddingLeft: 20,
          paddingRight: 40,
          color: '#546b81',
          fontSize: 14,
          outline: 'none',
        }}
        searchText={props.searchText}
        onUpdateInput={props.onUpdateInput}
        listStyle={{ width: '100%' }}
        menuItemStyle={{ width: '100%' }}
        filter={AutoComplete.fuzzyFilter}
        openOnFocus={true}
        onBlur={handleBlur}
        onNewRequest={handleNewRequest}
        dataSource={dataSource}
        id={props.id}
        name={props.name}
        placeholder={props.placeholder}
        menuStyle={{ maxHeight: '300px', minWidth: '500px' }}
        disabled={props.disabled}
      />
      <ArrowIcon />
    </div>
  )
}
